// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__Gg313","list":"BalanceDue_list__WxRzu","listRow":"BalanceDue_listRow__8VFd0","total":"BalanceDue_total__Q2iA5"};